const TURNING_ACTION_TYPES = {
  LOAD_TURNING: 'turning/LOAD_TURNING',
};

export default TURNING_ACTION_TYPES;
